export default function safeParse(raw) {
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}
